/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import makeApi, { URLS } from 'Utils/apiUtil';
import * as CONSTANTS from 'Utils/constants';
import Utils from 'Utils/utils';
import userDetail from 'Stores/userDetail';
import advSearchState from 'Stores/advSearch';
import { SocialLinks } from '../SocialLinks';
import { ContactEmailPhone } from './contactEmailPhone';
import { ContactLocation } from './contactLocation';
import { ContactCompany } from './contactCompany';

import { ReactComponent as LocationIcon } from '../../../../assets/svg/location.svg';
import { purchaseStatusPopupState } from '../purchaseStatusPopup';
import Dropdown from '../dropdown';

const ContactCard = props => {
  const {
    name,
    title,
    owned = false,
    cname,
    contactCity = '',
    contactState = '',
    contactCountry = '',
    companyCountry = '',
    companyState = '',
    companyCity = '',
    contactId,
    email,
    phoneNumberFromVendor,
    pageName = 'advsearch',
    status = '',
    score,
    LOCATION_PREFERENCE = false,
  } = props;
  const [
    showMarkAsInactiveConfirmation,
    setShowMarkAsInactiveConfirmation,
  ] = React.useState(false);

  const markAsInactiveClick = (e, masterContactId) => {
    const config = {
      url: URLS.reportMarkAsInactive,
      method: 'POST',
      params: {
        masterContactId,
      },
      data: {},
    };
    makeApi(config)
      .then(response => {
        if (response && response.data !== undefined && response.data === true)
          purchaseStatusPopupState.setToastMsg(
            null,
            null,
            null,
            null,
            null,
            'Contact marked as inactive.',
          );
        else
          purchaseStatusPopupState.setToastMsg(
            null,
            null,
            null,
            null,
            null,
            'Unable to process your request now. Please try later',
          );
        setShowMarkAsInactiveConfirmation(false);
      })
      .catch(error => {
        console.log('reportMarkAsInactive error ', error);
      });
  };
  return (
    <div
      className="contact-card"
      onMouseLeave={e => setShowMarkAsInactiveConfirmation(false)}
    >
      <span className="sharp-point" />
      <div className="contact-card-details">
        <div className="basic-info-wrapper">
          <div className="name-wrapper">
            <div className="contact-name">{name}</div>
            <SocialLinks {...props} />
          </div>
          <div className="title">{title}</div>
          <ContactCompany cname={cname} />
        </div>
        <div className="additional-info-wrapper">
          {email !== null && email !== undefined && (
            <ContactEmailPhone
              contactId={contactId}
              email={email}
              status={status}
              phoneNumberFromVendor={phoneNumberFromVendor}
              pageName={pageName}
              score={score}
              isDownloaded
            />
          )}
          {(contactCity !== '' ||
            contactState !== '' ||
            contactCountry !== '' ||
            companyCity !== '' ||
            companyState !== '' ||
            companyCountry !== '') && (
            <div className="contact-location-wrapper">
              {!LOCATION_PREFERENCE && (
                <div className="info-icon">
                  <LocationIcon />
                </div>
              )}
              <ContactLocation
                contactCity={contactCity}
                contactState={contactState}
                contactCountry={contactCountry}
                companyCountry={companyCountry}
                companyState={companyState}
                companyCity={companyCity}
                showContactLocation
                showCompanyLocation
                LOCATION_PREFERENCE={LOCATION_PREFERENCE}
              />
            </div>
          )}
          {status !== '' &&
            status !== 'DEAD' &&
            email !== null &&
            email !== undefined && (
              <div className="contact-card-action-wrapper">
                {showMarkAsInactiveConfirmation ? (
                  <>
                    <div
                      className="action-btn"
                      onClick={e => markAsInactiveClick(e, contactId)}
                    >
                      Confirm
                    </div>
                    <div
                      className="action-btn cancel-btn"
                      onClick={e => setShowMarkAsInactiveConfirmation(false)}
                    >
                      Cancel
                    </div>
                  </>
                ) : (
                  <div
                    className="action-btn"
                    onClick={e => setShowMarkAsInactiveConfirmation(true)}
                  >
                    Mark as Inactive
                  </div>
                )}
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

const ContactName = props => {
  const {
    name,
    title,
    contactId,
    owned = false,
    purchaseContact,
    contactCity,
    contactState,
    contactCountry,
  } = props;

  let contactStr = '';
  if (contactCity) contactStr += contactCity;
  if (contactState)
    if (contactStr !== '') contactStr += `, ${contactState}`;
    else contactStr += contactState;
  if (contactCountry)
    if (contactStr !== '') contactStr += `, ${contactCountry}`;
    else contactStr += contactCountry;

  const handleNameClick = (e, id) => {
    Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_CONTACT_NAME_CLICK, {
      contactName: name,
      LEAD_BUILDER:
        userDetail.featureFlags &&
        userDetail.featureFlags.LEAD_BUILDER !== undefined
          ? userDetail.featureFlags.LEAD_BUILDER
          : false,
    });
    purchaseContact(e, id);
  };

  return (
    <div className="contact-name">
      <div className="name-wrapper">
        {owned ? (
          <Dropdown
            toggleElement={
              <div className="name contact-card-wrapper">{name}</div>
            }
            showOnHover
          >
            <ContactCard {...props} />
          </Dropdown>
        ) : (
          <div className="name" onClick={e => handleNameClick(e, contactId)}>
            {name}
          </div>
        )}
        <SocialLinks {...props} />
      </div>
      <div className="title">{title}</div>
      {contactStr && (
        <div className="contact-address-info-wrap">
          <LocationIcon />
          <div className="contact-address-info show-elipsis" title={contactStr}>
            {contactStr}
          </div>
        </div>
      )}
    </div>
  );
};

export { ContactName };
export default ContactName;
